/**
 * Footer Component
 * Uses ES modules and CSS modules
 */

import styles from './Footer.module.css';

export class Footer {
  constructor() {
    this.socialLinks = [
      {
        name: 'Facebook',
        url: 'https://www.facebook.com/classicalballetofcalifornia',
        icon: 'facebook'
      },
      {
        name: 'Instagram',
        url: 'https://instagram.com/cbcdancers?igshid=wkj5ycm1iof4',
        icon: 'instagram'
      }
    ];
  }

  render() {
    const footer = document.createElement('footer');
    footer.className = styles.footer;
    footer.setAttribute('role', 'contentinfo');

    const container = document.createElement('div');
    container.className = styles.container;

    // Brand section
    const brandSection = document.createElement('div');
    brandSection.className = styles.brandSection;

    const brandName = document.createElement('h3');
    brandName.className = styles.brandName;
    brandName.textContent = 'Classical Ballet of California';

    const address = document.createElement('p');
    address.className = styles.address;
    address.innerHTML = '1919 Palmetto Ave<br>Pacifica, CA 94044<br><br>Phone: (650) 451-5001<br>Email: classicalballetofCA@gmail.com';

    brandSection.appendChild(brandName);
    brandSection.appendChild(address);

    // Social links
    const socialSection = document.createElement('div');
    socialSection.className = styles.socialSection;

    const socialList = document.createElement('ul');
    socialList.className = styles.socialList;
    socialList.setAttribute('aria-label', 'Social media links');

    this.socialLinks.forEach(link => {
      const listItem = document.createElement('li');
      const anchor = document.createElement('a');
      anchor.href = link.url;
      anchor.target = '_blank';
      anchor.rel = 'noopener noreferrer';
      anchor.className = styles.socialLink;
      anchor.setAttribute('aria-label', link.name);
      anchor.textContent = link.name;
      
      listItem.appendChild(anchor);
      socialList.appendChild(listItem);
    });

    socialSection.appendChild(socialList);

    // Copyright
    const copyright = document.createElement('p');
    copyright.className = styles.copyright;
    copyright.textContent = `© ${new Date().getFullYear()} Classical Ballet of California. All rights reserved.`;

    container.appendChild(brandSection);
    container.appendChild(socialSection);
    container.appendChild(copyright);
    footer.appendChild(container);

    return footer;
  }
}
